import type { Dictionary } from "../lib/i18n";

/**
 * Det som står i baren nederst til høyre.
 *
 * ── Hvorfor det ikke står oppdiktede anmeldelser her ───────────────────────
 *
 * Ønsket som ble meldt var «to eller tre dummy-anmeldelser, så
 * førstegangsbrukere ser at nettsiden er troverdig». Målet er riktig; midlet
 * ville ha motarbeidet det. Oppdiktede anmeldelser presentert som ekte er
 * villedende overfor den som leser dem, og forbudt etter markedsføringsloven
 * §§ 6–8 — Forbrukertilsynet håndhever det, og EU-direktivet bak har en
 * bøteramme på fire prosent av omsetningen. Verre enn boten: det er nettopp den
 * slags som ødelegger tilliten hvis noen ser gjennom den.
 *
 * ── Det som står her i stedet ──────────────────────────────────────────────
 *
 * Fem påstander om appen som alle er sanne og kan etterprøves av den som leser
 * dem. Det er også et sterkere argument: «vær fra MET, avganger fra Entur,
 * veimeldinger fra Statens vegvesen» sier noe konkret om hvorfor tallene
 * stemmer, mens «Flott app!! 5 stjerner – Anna, Berlin» ikke sier noe om noe
 * som helst.
 *
 * Hver av dem er sjekket mot koden i denne runden, ikke antatt:
 *
 *   trustLive       — kildene finnes i api/src/services/
 *   trustStops      — 118 stopp i api/src/data/stops/
 *   trustNoTracking — ingen treff på analytics, gtag, plausible, hotjar,
 *                     posthog, segment eller facebook i hele web/
 *   trustHonest     — merket «anslag, ikke et varsel» over ni døgn, se
 *                     ExtendedPanel
 *   trustFree       — ingen innlogging finnes i kodebasen
 *
 * ── Når ekte tilbakemeldinger kommer ───────────────────────────────────────
 *
 * Legg dem i `FEEDBACK` under. Da viser baren dem i stedet, og påstandene over
 * blir reserven. Én regel: ordene skal være dem som ble skrevet. Ikke stram
 * dem opp, ikke slå to sammen, ikke oversett dem — en tilbakemelding på tysk
 * hører hjemme på tysk. Er du i tvil om noen vil bli sitert, la være.
 */
export const TRUST_NOTES = [
  "trustLive",
  "trustStops",
  "trustNoTracking",
  "trustHonest",
  "trustFree",
] as const satisfies readonly (keyof Dictionary)[];

export interface Quote {
  /** Ordene, slik de ble skrevet. Se regelen over. */
  text: string;
  /** Fornavn og sted, når personen har sagt at det er greit. */
  who: string;
  /** Måneden den kom inn, som ÅÅÅÅ-MM. */
  when: string;
}

/**
 * Ekte tilbakemeldinger, når de finnes.
 *
 * Tom med vilje — se doc-kommentaren over. Skjemaet i baren samler dem inn til
 * innboksen; herfra går de ut på siden, én for én, etter at et menneske har
 * lest dem.
 */
export const FEEDBACK: Quote[] = [];
